let indexCounter = 0;
const cancelablesMap = new Map();

const registerCancelable = () => {
	const index = indexCounter;
	indexCounter++;
	cancelablesMap.set(index, true);
	const isCancelled = () => !cancelablesMap.has(index);
	const cancel = () => cancelablesMap.delete(index);
	return { isCancelled, cancel };
};

export default registerCancelable;
